<!-- <mat-card > -->
  <mat-card-header class="pb-3">
    <mat-card-title>User Mobile Device Status</mat-card-title>
  </mat-card-header>
  <mat-dialog-content>
    <div
      class="d-flex justify-content-between align-items-baseline align-content-center p-2"
      *ngFor="let data of deviceStatusData"
    >
      <div class="mx-3">{{ data.key }}</div>
      <div>{{ data.value }}</div>
    </div>
  </mat-dialog-content>
  <mat-card-actions class="d-flex justify-content-end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-card-actions>
<!-- </mat-card> -->
